export const GET_STUDENT_WORK_OSS_POLICY_SUCCESS = 'GET_STUDENT_WORK_OSS_POLICY_SUCCESS';
export const SET_ASSIGNMENT_ID = 'SET_ASSIGNMENT_ID';
export const GET_STUDENT_WORK_LIST_SUCCESS = 'GET_STUDENT_WORK_LIST_SUCCESS';
export const UPDATE_STUDENT_WORK = 'UPDATE_STUDENT_WORK';
export const CLEAR_OBJ_STUDENT_WORKS = 'CLEAR_OBJ_STUDENT_WORKS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
